export default "<h3> Please <sh-click-to-download file=\"vm.attachment\"></sh-click-to-download> download this file to open it. </h3> ";